import { render } from "./LogsTable.html?vue&type=template&id=9a278e8e&scoped=true"
import script from "./LogsTable.js?vue&type=script&lang=js"
export * from "./LogsTable.js?vue&type=script&lang=js"

import "./LogsTable.css?vue&type=style&index=0&id=9a278e8e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a278e8e"]])

export default __exports__